import { useLocalStore } from 'mobx-react'

import { TENANT_ID_MAP } from '@/constants'
import GStore from '@/store'

// 租户信息
const useTenantInfo = () => {
  const { userData } = useLocalStore(() => GStore)
  const testTenant = [
    TENANT_ID_MAP.heihe_test,
    TENANT_ID_MAP.TestMigration01,
    TENANT_ID_MAP.Testdata_wx
  ]
  // 是否是喜来登
  const isXilaideng = [TENANT_ID_MAP.xilaideng, ...testTenant].includes(Number(userData?.tenant_id))
  return {
    isXilaideng,
    tenant_name: userData?.tenant_name
  }
}

export default useTenantInfo
